import React from "react";
import { connect } from "react-redux";
import axios from "axios";
import routes from "../../assets/apiRoutes.json";
import ArrayStore from "devextreme/data/array_store";
import { ABECASUSER_LOGIN_TYPE } from "../../common/permissions";
import { TabPanel, Item as TabItem } from 'devextreme-react/tab-panel';
import Toolbar, { Item as ToolbarItem } from "devextreme-react/toolbar";
import { Button } from "devextreme-react/button";
import { CheckBox } from "devextreme-react/check-box";
import { TextBox } from "devextreme-react/text-box";
// Aliased: `Item` from devextreme-react/toolbar is already imported as ToolbarItem above.
import Popup, { ToolbarItem as PopupToolbarItem } from "devextreme-react/popup";
import DataGrid, { Column, Paging, SearchPanel, Selection } from "devextreme-react/data-grid";
import notify from "devextreme/ui/notify";
import { confirm } from "devextreme/ui/dialog";
import { CONCURRENCY_HANDLED, getApiErrorMessage } from "../../common/concurrency";
import { MESSAGES } from "../../common/Messages";
import ReportFilter from "./ReportFilter";

const searchpanel = [
  {
    ID: 1,
    Name: 'Search Filters'
  }
];

// Flag (coded) filter fields are stored by value but shown by description, so both the report load
// and the macro load translate them the same way.
const FLAG_FIELD_TYPE = 5;

// Length of ABLAYOUT.LAYOUTNAME, which a macro shares with the report name (see the server-side
// ReportLayoutIds).
const MACRO_LAYOUT_NAME_MAX_LENGTH = 50;

// A macro is stored as {macro}:{report}:{report}, so two separators are spent on top of the report
// name twice over. Named rather than left as a bare + 2 in the arithmetic below.
const MACRO_LAYOUT_NAME_SEPARATOR_COUNT = 2;

let accessToken = "";

class CommonReport extends React.Component {
  constructor(props) {
    super(props);
    accessToken = props.oidc.user.access_token;
    this.gridRefs = {};
    this.state = {
      animationDuration: 300,
      selectedItems: searchpanel,
      loadIndicatorVisible: false,
      isGetReportPopupVisible: false,
      isReportInProgressPopupVisible: false,
      connection: null,
      opened: (props.oidc.user.profile.hasOwnProperty("LOGINTYPEID") && props.oidc.user.profile.LOGINTYPEID == ABECASUSER_LOGIN_TYPE),
      generatedFileName: "",
      // Saved range macros for this report. Loaded with the report, refreshed after a save.
      macroList: [],
      isMacroListPopupVisible: false,
      isMacroSavePopupVisible: false,
      macroNameInput: "",
      macroDefaultInput: false,
      macroSaving: false,
      // Opaque optimistic-concurrency token of the macro currently loaded. Echoed back when that
      // macro is overwritten, replaced with the token the save returns. Never displayed or parsed.
      macroConcurrencyToken: null,
      report: {
        key: "",
        name: "",
        fullName: "",
        formatName: "",
        macroName: "",
        fileFormat: "PDF",
        tabText: "",
        ignoreCompany: false,
        parameterList: [],
        queryParameters: [],
        whereInfoList: [],
        filterWhereInfoList: [
        ],
        subreportList: []
      },
      formData: {},
      formItems: [],
    };


    this.loadReport = this.loadReport.bind(this);
    this.loadMacroList = this.loadMacroList.bind(this);
    this.applyMacro = this.applyMacro.bind(this);
    this.openMacroListPopup = this.openMacroListPopup.bind(this);
    this.openMacroSavePopup = this.openMacroSavePopup.bind(this);
    this.macroListSelectionChanged = this.macroListSelectionChanged.bind(this);
    this.macroRowDoubleClicked = this.macroRowDoubleClicked.bind(this);
    this.loadSelectedMacro = this.loadSelectedMacro.bind(this);
    this.saveMacro = this.saveMacro.bind(this);
    this.getRangeFilters = this.getRangeFilters.bind(this);
    this.loadReport();
  }

  componentDidMount() {
    if (this.props.innerRef) {
      this.props.innerRef.current = {
        loadReport: this.loadReport,
        // Lets a hosting screen use this component purely as a range picker: it reads the criteria back
        // and applies them to its own query instead of generating a report.
        getRangeFilters: this.getRangeFilters,
        getReport: () => this.state.report,
      };
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.Name !== this.props.Name) {
      this.loadReport();
    }
  }

  /** Report code the macros of this screen are stored against. */
  getReportName() {
    return this.state.report.name || this.props.name;
  }

  /** Request config every call on this screen uses. One place, so the token cannot be forgotten on a new one. */
  requestConfig() {
    return {
      headers: {
        "Content-Type": "application/json",
        access_token: accessToken,
        Authorization: `Bearer ${accessToken}`,
      },
    };
  }

  /**
   * Flushes any criteria cell still in edit mode into its grid's data source, or the value the user just
   * typed is left out of whatever is about to read the criteria.
   *
   * gridRefs is keyed by tab index, not an array - a for/length loop over it would run zero times.
   */
  async commitPendingGridEdits() {
    const gridInstances = Object.values(this.gridRefs).filter((grid) => grid != null);
    for (let i = 0; i < gridInstances.length; i++) {
      await gridInstances[i].instance().saveEditData();
    }
  }

  /**
   * ABLAYOUT.LAYOUTNAME is 50 characters and a macro spends {macro}:{report}:{report} of it, so what
   * is left for the name depends on the report. Mirrors the server-side rule (ReportLayoutIds) to keep
   * the user from typing a name the API would then reject.
   */
  getMacroNameMaxLength() {
    const reportName = this.getReportName() || "";
    return MACRO_LAYOUT_NAME_MAX_LENGTH - ((reportName.length * 2) + MACRO_LAYOUT_NAME_SEPARATOR_COUNT);
  }

  render() {
    // Hidden unless the hosting screen opts in, so the screens that only ever use their own filters
    // are unchanged.
    const showMacroButtons = this.props.showMacroButtons === true;
    const macroNameMaxLength = this.getMacroNameMaxLength();
    // Hosted inside a dialog rather than on a report page: the fields list sits beside the criteria grid and
    // both panes take the height the host can spare (paneHeight), instead of the viewport-based heights the
    // report pages use.
    const embedded = this.props.embedded === true;

    return (
      <div className="h-100 m-0" style={{ height: '100%',overflowY: 'hidden' }}>
        {showMacroButtons &&
          <Toolbar>
            <ToolbarItem location="before">
              <div className="title">
                <h6 style={{ color: window._env_.Color2, marginBottom: 0 }}>
                  {MESSAGES.MACRO_CURRENT_LABEL.replace("{0}", this.state.report.macroName || MESSAGES.MACRO_NONE_SELECTED)}
                </h6>
              </div>
            </ToolbarItem>
            <ToolbarItem location="after">
              <Button
                className="accordianButton"
                icon="find"
                text={MESSAGES.MACRO_FIND_TITLE}
                hint={MESSAGES.MACRO_FIND_TITLE}
                onClick={this.openMacroListPopup}
              />
            </ToolbarItem>
            <ToolbarItem location="after">
              <Button
                className="accordianButton"
                icon="save"
                text={MESSAGES.MACRO_SAVE_TITLE}
                hint={MESSAGES.MACRO_SAVE_TITLE}
                type="default"
                onClick={this.openMacroSavePopup}
              />
            </ToolbarItem>
          </Toolbar>
        }
        <TabPanel deferRendering={false} showNavButtons={true} height={"auto"}>
          <TabItem title={this.state.report.tabText == "" || this.state.report.tabText == null ? "Available Fields" : this.state.report.tabText}>
            <ReportFilter selectedItems={this.state.selectedItems} formItems={this.state.formItems} whereInfoList={this.state.report.whereInfoList} gridRefs={this.gridRefs} rowIndex={0} embedded={embedded} paneHeight={this.props.paneHeight} />
          </TabItem>
          {this.state.report.subreportList.map((m, i) => (
            <TabItem key={i + 1} title={m.tabText}>
              <ReportFilter selectedItems={this.state.selectedItems} formItems={this.state.formItems} whereInfoList={m.whereInfoList} gridRefs={this.gridRefs} rowIndex={i+1} embedded={embedded} paneHeight={this.props.paneHeight} />
            </TabItem>
          ))}
        </TabPanel>

        {this.state.isMacroListPopupVisible &&
          <Popup
            visible={this.state.isMacroListPopupVisible}
            onHiding={() => this.setState({ isMacroListPopupVisible: false })}
            dragEnabled={true}
            hideOnOutsideClick={true}
            showCloseButton={true}
            showTitle={true}
            title={MESSAGES.MACRO_FIND_TITLE}
            container=".dx-viewport"
            width={640}
            height={440}
          >
            {/* The grid takes the whole content area; the match count and OK live in the popup's own bottom
                toolbar, so they stay pinned to the footer instead of floating under a short list. */}
            <DataGrid
              dataSource={this.state.macroList}
              keyExpr="macroName"
              rowAlternationEnabled={false}
              columnAutoWidth={true}
              hoverStateEnabled={true}
              focusedRowEnabled={true}
              height="100%"
              noDataText={MESSAGES.MACRO_NO_DATA}
              defaultSelectedRowKeys={this.state.report.macroName ? [this.state.report.macroName] : []}
              defaultFocusedRowKey={this.state.report.macroName || undefined}
              onSelectionChanged={this.macroListSelectionChanged}
              onRowDblClick={this.macroRowDoubleClicked}
            >
              <Selection mode="single" />
              <SearchPanel visible={true} width={260} placeholder={MESSAGES.MACRO_SEARCH_PLACEHOLDER} />
              <Paging enabled={false} />
              <Column dataField="macroName" caption="Macro Name" defaultSortOrder="asc" />
              <Column
                dataField="defaultFlag"
                caption="Default"
                dataType="boolean"
                width={90}
                alignment="center"
                allowSearch={false}
                // A tick on the default macro reads better in a picker than a column of empty checkboxes.
                cellRender={(cell) => (cell.value ? <i className="dx-icon-check" /> : null)}
              />
              <Column dataField="formatName" caption="Format" width={200} />
            </DataGrid>
            <PopupToolbarItem
              toolbar="bottom"
              location="before"
              render={() => (
                <span className="text-muted">
                  {MESSAGES.MACRO_MATCHING_COUNT.replace("{0}", this.state.macroList.length)}
                </span>
              )}
            />
            <PopupToolbarItem
              toolbar="bottom"
              location="after"
              widget="dxButton"
              options={{
                text: "OK",
                type: "default",
                stylingMode: "contained",
                elementAttr: { class: "accordianButton" },
                width: 110,
                onClick: this.loadSelectedMacro,
              }}
            />
          </Popup>
        }

        {this.state.isMacroSavePopupVisible &&
          <Popup
            visible={this.state.isMacroSavePopupVisible}
            onHiding={() => this.setState({ isMacroSavePopupVisible: false })}
            dragEnabled={true}
            hideOnOutsideClick={false}
            showCloseButton={true}
            showTitle={true}
            title={MESSAGES.MACRO_SAVE_TITLE}
            container=".dx-viewport"
            width={480}
            height={250}
          >
            <div>
              <div className="row">
                <div className="col-md-12">
                  <TextBox
                    value={this.state.macroNameInput}
                    stylingMode="outlined"
                    labelMode="static"
                    label={MESSAGES.MACRO_NAME_LABEL}
                    showClearButton={true}
                    maxLength={macroNameMaxLength > 0 ? macroNameMaxLength : undefined}
                    onValueChanged={(e) => this.setState({ macroNameInput: e.value })}
                  />
                  <small className="text-muted">
                    {macroNameMaxLength > 0
                      ? MESSAGES.MACRO_NAME_MAX_LENGTH.replace("{0}", macroNameMaxLength)
                      : MESSAGES.MACRO_NAME_NOT_SUPPORTED}
                  </small>
                </div>
              </div>
              <div className="row" style={{ marginTop: "15px" }}>
                <div className="col-md-12">
                  <CheckBox
                    value={this.state.macroDefaultInput}
                    text={MESSAGES.MACRO_SET_AS_DEFAULT}
                    onValueChanged={(e) => this.setState({ macroDefaultInput: e.value })}
                  />
                </div>
              </div>
            </div>
            {/* Same footer treatment as the Find dialog. Cancel stays here: this one takes input, so
                backing out has to be an explicit choice rather than only the title-bar close. */}
            <PopupToolbarItem
              toolbar="bottom"
              location="after"
              widget="dxButton"
              options={{
                text: "OK",
                type: "default",
                stylingMode: "contained",
                elementAttr: { class: "accordianButton" },
                width: 110,
                disabled: this.state.macroSaving || macroNameMaxLength <= 0,
                onClick: this.saveMacro,
              }}
            />
            <PopupToolbarItem
              toolbar="bottom"
              location="after"
              widget="dxButton"
              options={{
                text: "Cancel",
                stylingMode: "outlined",
                elementAttr: { class: "accordianButton" },
                width: 110,
                onClick: () => this.setState({ isMacroSavePopupVisible: false }),
              }}
            />
          </Popup>
        }
      </div>
    );
  }

  /**
   * Flag filters travel as codes and are shown as descriptions. Applied to every filter list the API
   * returns - the report itself, a macro, and both of those for each subreport.
   */
  mapFlagFiltersToText(whereInfoList) {
    for (var i = 0; whereInfoList != null && i < whereInfoList.length; i++) {
      if (whereInfoList[i].fieldType !== FLAG_FIELD_TYPE) {
        continue;
      }

      for (var j = 0; whereInfoList[i].items != null && j < whereInfoList[i].items.length; j++) {
        if (whereInfoList[i].from == whereInfoList[i].items[j].value) {
          whereInfoList[i].from = whereInfoList[i].items[j].text;
        }

        if (whereInfoList[i].to == whereInfoList[i].items[j].value) {
          whereInfoList[i].to = whereInfoList[i].items[j].text;
        }
      }
    }

    return whereInfoList;
  }

  /** Reverse of mapFlagFiltersToText, so a saved macro holds the codes the report expects. */
  mapFlagFiltersToValue(whereInfoList) {
    return (whereInfoList || []).map((whereInfo) => {
      if (whereInfo.fieldType !== FLAG_FIELD_TYPE || whereInfo.items == null) {
        return whereInfo;
      }

      const mapped = { ...whereInfo };
      for (var j = 0; j < whereInfo.items.length; j++) {
        if (mapped.from == whereInfo.items[j].text) {
          mapped.from = whereInfo.items[j].value;
        }

        if (mapped.to == whereInfo.items[j].text) {
          mapped.to = whereInfo.items[j].value;
        }
      }

      return mapped;
    });
  }

  /**
   * The criteria currently on screen, ready to be sent to an API that filters in SQL.
   *
   * Pending cell edits are committed first, flag values are turned back into their stored codes, and the
   * payload is cut down to the fields the server needs — the `items` lists behind the flag dropdowns are
   * dropped because they would dominate the size of a query-string filter and the server never reads them.
   */
  async getRangeFilters() {
    await this.commitPendingGridEdits();

    return this.mapFlagFiltersToValue(this.state.report.filterWhereInfoList)
      .filter((row) => row && (
        (row.from !== null && row.from !== undefined && row.from !== "") ||
        (row.orderBy !== undefined && row.orderBy !== null && row.orderBy !== 0)
      ))
      .map((row) => ({
        displayLabel: row.displayLabel,
        fieldName: row.fieldName,
        origin: row.origin,
        fieldType: row.fieldType,
        operation: row.operation,
        prefix: row.prefix,
        group: row.group,
        include: row.include,
        orderBy: row.orderBy,
        from: row.from,
        to: row.to,
      }));
  }

  /** Pushes a filter list into the grid of the given tab. */
  setFilterGridDataSource(rowIndex, filterWhereInfoList) {
    const grid = this.gridRefs[rowIndex];
    if (!grid) {
      return;
    }

    grid.instance().option("dataSource", new ArrayStore({
      data: filterWhereInfoList || [],
    }));
  }

  loadReport() {
    var that = this;
    axios
      .get(
        `${window._env_.REACT_APP_APIS}/${routes.reports.GetReport}?reportName=${this.props.name}&reportFullName=${this.props.fullName}`,
        this.requestConfig()
      )
      .then((res) => {

        that.mapFlagFiltersToText(res.data.filterWhereInfoList);
        that.mapFlagFiltersToText(res.data.whereInfoList);

        for (
          var i = 0;
          res.data.subreportList != null &&
          i < res.data.subreportList.length;
          i++
        )
        {
          that.mapFlagFiltersToText(res.data.subreportList[i].filterWhereInfoList);
          that.mapFlagFiltersToText(res.data.subreportList[i].whereInfoList);
        }

        that.setState({
          report: res.data,
          // A report opened fresh carries whatever macro the API applied as the default; its token is
          // only known once the macro list arrives.
          macroConcurrencyToken: null,
        }, () => {
          // Notify parent component of report state change
          if (that.props.onReportStateChange) {
            that.props.onReportStateChange(res.data);
          }
        });

        var formData = new Object();

        var formItems = [];

        for (
          var i = 0;
          that.state.report.parameterList != null &&
          i < that.state.report.parameterList.length;
          i++
        ) {
          formData[that.state.report.parameterList[i].name] =
            that.state.report.parameterList[i].value;
          var formItem = new Object();
          formItem.dataField = that.state.report.parameterList[i].name;
          formItem.label = new Object();
          formItem.label.text = that.state.report.parameterList[i].label;
          switch (that.state.report.parameterList[i].parameterType) {
            case 1: // Integer
            case 2: // Decimal
              formItem.editorType = "dxNumberBox";
              break;
            case 3: // Boolean
              formItem.editorType = "dxCheckBox";
              break;
            case 4: // DateTime
              formItem.editorType = "dxDateBox";
              break;
            case 5: // Flag
              formItem.editorType = "dxSelectBox";
              formItem.editorOptions = new Object();
              formItem.editorOptions.items = [];

              for (
                var j = 0;
                j < that.state.report.parameterList[i].items.length;
                j++
              ) {
                var selectBoxItem = new Object();
                selectBoxItem.Value =
                  that.state.report.parameterList[i].items[j].value;
                selectBoxItem.Text =
                  that.state.report.parameterList[i].items[j].text;
                formItem.editorOptions.items.push(selectBoxItem);
              }

              formItem.editorOptions.displayExpr = "Text";
              formItem.editorOptions.valueExpr = "Value";
              break;
            default:
              formItem.editorType = "dxTextBox";
          }

          formItems.push(formItem);
        }

        that.setState({
          formData: formData,
        });

        that.setState({
          formItems: formItems,
        });

        that.setFilterGridDataSource(0, that.state.report.filterWhereInfoList);

        for (
          var i = 0;
          that.state.report.subreportList != null &&
          i < that.state.report.subreportList.length;
          i++
        )
        {
          that.setFilterGridDataSource(i + 1, that.state.report.subreportList[i].filterWhereInfoList);
        }

        that.loadMacroList();
      })
      .catch((err) => {
        console.log(err, "Error getting report data");
      });
  }

  /**
   * Saved macros for this report, with the default flag and the concurrency token the overwrite path
   * needs. Silent on failure beyond the console: the macro picker is optional, and the report screen
   * is still usable without it.
   */
  loadMacroList() {
    if (this.props.showMacroButtons !== true) {
      return;
    }

    var that = this;
    const reportName = this.getReportName();
    if (!reportName) {
      return;
    }

    axios
      .get(
        `${window._env_.REACT_APP_APIS}/${routes.reports.GetReportMacroList}?reportName=${encodeURIComponent(reportName)}&formatName=${encodeURIComponent(this.state.report.formatName || "")}`,
        this.requestConfig()
      )
      .then((res) => {
        const macroList = Array.isArray(res.data) ? res.data : [];
        const currentMacro = macroList.find((m) => m.macroName === that.state.report.macroName);

        that.setState({
          macroList: macroList,
          // Token of the macro the report opened with, if the API applied one as the default.
          macroConcurrencyToken: currentMacro ? currentMacro.concurrencyToken : that.state.macroConcurrencyToken,
        });
      })
      .catch((err) => {
        console.log(err, "Error getting report macro list");
      });
  }

  openMacroListPopup() {
    this.loadMacroList();
    // Pre-selected row = the macro in use, so OK straight after opening reloads that one.
    this.selectedMacroName = this.state.report.macroName || null;
    this.setState({ isMacroListPopupVisible: true });
  }

  openMacroSavePopup() {
    this.setState({
      isMacroSavePopupVisible: true,
      macroNameInput: this.state.report.macroName || "",
      macroDefaultInput: this.isCurrentMacroDefault(),
    });
  }

  isCurrentMacroDefault() {
    const current = this.state.macroList.find((m) => m.macroName === this.state.report.macroName);
    return current ? current.defaultFlag === true : false;
  }

  macroListSelectionChanged(e) {
    this.selectedMacroName = e.selectedRowKeys && e.selectedRowKeys.length ? e.selectedRowKeys[0] : null;
  }

  macroRowDoubleClicked(e) {
    if (e.data && e.data.macroName) {
      this.applyMacro(e.data.macroName);
    }
  }

  loadSelectedMacro() {
    if (!this.selectedMacroName) {
      notify(MESSAGES.MACRO_SELECT_ROW, "warning", 3000);
      return;
    }

    this.applyMacro(this.selectedMacroName);
  }

  /**
   * Loads a macro's saved selection into the filter grids, the question form and the report state the
   * hosting screen generates from - all three, or the screen would show one set of criteria and run
   * another.
   */
  applyMacro(macroName) {
    var that = this;
    const reportName = this.getReportName();

    axios
      .get(
        `${window._env_.REACT_APP_APIS}/${routes.reports.GetReportDataByMacro}?macro=${encodeURIComponent(macroName)}&reportName=${encodeURIComponent(reportName)}`,
        this.requestConfig()
      )
      .then((result) => {
        if (!result.data) {
          notify(MESSAGES.MACRO_LOAD_ERROR, "error", 5000);
          return;
        }

        const macroFilters = that.mapFlagFiltersToText(result.data.filterWhereInfoList) || [];
        const macroParameters = result.data.parameterList || [];

        // Keep the report's own field list and subreports: a macro only carries the selection.
        const report = {
          ...that.state.report,
          macroName: macroName,
          filterWhereInfoList: macroFilters,
          parameterList: macroParameters.length ? macroParameters : that.state.report.parameterList,
        };

        const formData = { ...that.state.formData };
        for (var i = 0; i < macroParameters.length; i++) {
          formData[macroParameters[i].name] = macroParameters[i].value;
        }

        const selectedMacro = that.state.macroList.find((m) => m.macroName === macroName);

        that.setState({
          report: report,
          formData: formData,
          isMacroListPopupVisible: false,
          macroConcurrencyToken: selectedMacro ? selectedMacro.concurrencyToken : null,
        }, () => {
          that.setFilterGridDataSource(0, report.filterWhereInfoList);

          for (
            var i = 0;
            result.data.subreportList != null && i < result.data.subreportList.length;
            i++
          ) {
            that.setFilterGridDataSource(i + 1, that.mapFlagFiltersToText(result.data.subreportList[i].filterWhereInfoList));
          }

          if (that.props.onReportStateChange) {
            that.props.onReportStateChange(report);
          }
        });
      })
      .catch((err) => {
        console.log(err, "Error getting report data by macro");
        notify(getApiErrorMessage(err, MESSAGES.MACRO_LOAD_ERROR), "error", 5000);
      });
  }

  /**
   * Saves the criteria currently on screen under a name. An existing name is an overwrite, confirmed
   * first, which is what the legacy Save As did.
   */
  async saveMacro() {
    const macroName = (this.state.macroNameInput || "").trim();
    if (!macroName) {
      notify(MESSAGES.MACRO_NAME_REQUIRED, "warning", 3000);
      return;
    }

    const existing = this.state.macroList.find((m) => m.macroName === macroName);
    if (existing) {
      const replace = await confirm(
        `<i>${MESSAGES.MACRO_OVERWRITE_CONFIRM.replace("{0}", macroName)}</i>`,
        MESSAGES.MACRO_SAVE_TITLE
      );

      if (!replace) {
        return;
      }
    }

    await this.commitPendingGridEdits();

    // Question-form answers live in formData until a report runs; fold them in the same way.
    const parameterList = (this.state.report.parameterList || []).map((parameter) => ({
      ...parameter,
      value: this.state.formData[parameter.name],
    }));

    const payload = {
      macroName: macroName,
      reportName: this.getReportName(),
      formatName: this.state.report.formatName || "",
      defaultFlag: this.state.macroDefaultInput === true,
      // Only meaningful on an overwrite, and then it is the token of the newest version this screen has
      // seen: the one a save/apply handed back for the macro currently loaded, otherwise the one the
      // macro list carried. Sending null on the second case would waive the check entirely and let a
      // Save As over someone else's macro silently discard their edit.
      concurrencyToken: existing
        ? ((existing.macroName === this.state.report.macroName ? this.state.macroConcurrencyToken : null)
            || existing.concurrencyToken
            || null)
        : null,
      filterWhereInfoList: this.mapFlagFiltersToValue(this.state.report.filterWhereInfoList),
      parameterList: parameterList,
    };

    const endpoint = existing ? routes.reports.UpdateReportMacro : routes.reports.InsertReportMacro;
    const method = existing ? "put" : "post";

    this.setState({ macroSaving: true });

    try {
      const resp = await axios[method](
        `${window._env_.REACT_APP_APIS}/${endpoint}`,
        payload,
        this.requestConfig()
      );

      const saved = resp?.data;

      this.setState((prevState) => ({
        isMacroSavePopupVisible: false,
        report: { ...prevState.report, macroName: macroName },
        // Adopt the token of the version just written; echoing the old one would falsely conflict.
        macroConcurrencyToken: saved?.concurrencyToken || null,
      }), () => {
        this.loadMacroList();

        if (this.props.onReportStateChange) {
          this.props.onReportStateChange(this.state.report);
        }
      });

      notify(MESSAGES.MACRO_SAVE_SUCCESS.replace("{0}", macroName), "success", 3000);
    } catch (err) {
      // A stale overwrite already raised the central "record changed" dialog; don't stack a toast.
      if (err?.[CONCURRENCY_HANDLED]) {
        return;
      }

      notify(getApiErrorMessage(err, MESSAGES.MACRO_SAVE_ERROR), "error", 5000);
    } finally {
      this.setState({ macroSaving: false });
    }
  }

}

function mapStateToProps(state) {
  return {
    ReceiptReducer: state.ReceiptReducer,
    oidc: state.oidc,
  };
}

export default connect(mapStateToProps)(CommonReport);
